import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
const chips = ['+300 pág.', '60+ protocolos aplicables', 'Recetas anti-inflamatorias', 'Checklist de crisis listos', 'Auditoría de hogar', 'Planificación anual 2026', 'Bebés y niños pequeños', 'Edad escolar', 'Deporte y recreo', 'Hogar', 'Nutrición', 'Ejercicio', 'Crisis nocturnas', 'Colegio', 'Estaciones'];
const contents = ['Control ambiental y anti-ácaros', 'Nutrición anti-inflamatoria argentina', 'Ejercicios respiratorios para niños', 'Protocolo de crisis nocturna paso a paso', 'Manual para el colegio y el docente', 'Calendario de riesgo estacional 2026', 'Botiquín natural de la cocina', 'Técnicas de calma para el niño y la madre', 'Plan de retorno al deporte', 'Guía de infusiones seguras y prohibidas'];
export const SystemFeatures = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-238">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <div className="text-center mb-6 sm:mb-10" data-id="element-240">
          <div className="inline-block bg-brand-gold/20 text-brand-green font-bold px-4 py-1.5 rounded-full text-sm mb-3 sm:mb-4" data-id="element-241">
            SISTEMA N°1 EN ARGENTINA
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-242">
            Para Madres de Niños Asmáticos
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-brand-orange font-semibold" data-id="element-243">
            Sistema completo · 3 Tomos + 3 Bonos · De 2 a 12 años · Todo
            resuelto.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 sm:mb-10 md:mb-12" data-id="element-244">
          {chips.map((chip, i) => <span key={i} className="flex items-center gap-1.5 bg-brand-green/5 text-brand-green px-3 py-1.5 rounded-full font-medium border border-brand-green/10 text-xs sm:text-sm" data-id="element-245">
              <CheckCircle2 size={14} className="text-brand-green" data-id="element-246" />
              {chip}
            </span>)}
        </motion.div>

        <div className="bg-cream-dark rounded-2xl p-5 sm:p-6 md:p-8 border border-brand-orange/20 shadow-sm text-center mb-8 sm:mb-10 md:mb-12" data-id="element-247">
          <p className="text-base sm:text-lg md:text-xl font-heading font-semibold text-gray-800" data-id="element-248">
            Funciona desde esta semana en tu hogar, ya sea departamento, casa,
            zona húmeda o clima seco.
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-249">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 flex items-center gap-2 justify-center" data-id="element-250">
            <BookOpen className="text-brand-orange" size={24} data-id="element-251" /> Contenidos
            incluidos:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3" data-id="element-252">
            {contents.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-253">
                <div className="mt-1 bg-brand-orange/20 p-1 rounded-full" data-id="element-254">
                  <div className="w-2 h-2 bg-brand-orange rounded-full" data-id="element-255"></div>
                </div>
                <span className="text-gray-700 font-medium text-sm sm:text-base" data-id="element-256">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};